import Theme from 'actions/theme';

export default Theme.createReducer();